export default __webpack_public_path__ + "static/media/telegram.9b7f801d.svg";